import React, { useState } from 'react';

const LocalhostFormatter = () => {
  const [htmlInput, setHtmlInput] = useState('');
  const [copied, setCopied] = useState(false);

  const transformContent = (content) => {
    if (!content) return '';

    return content
      .replace(/http:\/\/localhost:8082/g, 'https://www.theparentz.com')
      .replace(/content="noindex,nofollow"/g, 'content="index,follow"');
  };

  const transformedHtml = transformContent(htmlInput);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(transformedHtml);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      alert('Failed to copy');
    }
  };

  return (
    <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif' }}>
      <h2>HTML Input</h2>

      <textarea
        placeholder="Paste your HTML here..."
        value={htmlInput}
        onChange={(e) => setHtmlInput(e.target.value)}
        style={{
          width: '100%',
          height: '200px',
          padding: '10px',
          fontSize: '14px',
          boxSizing: 'border-box',
        }}
      />

      <h2 style={{ marginTop: '30px' }}>Updated HTML Output</h2>

      <textarea
        value={transformedHtml}
        readOnly
        style={{
          width: '100%',
          height: '500px',
          padding: '10px',
          fontSize: '14px',
          boxSizing: 'border-box',
          backgroundColor: '#f5f5f5',
        }}
      />

      <div style={{ marginTop: '10px', textAlign: 'right' }}>
        <button
          onClick={handleCopy}
          disabled={!transformedHtml}
          style={{
            padding: '8px 16px',
            fontSize: '14px',
            cursor: transformedHtml ? 'pointer' : 'not-allowed',
          }}>
          {copied ? 'Copied ✅' : 'Copy'}
        </button>
      </div>
    </div>
  );
};

export default LocalhostFormatter;
